import { mapState } from 'vuex';
import { db } from '@/db';
import MatchSheetPlayer from '@/components/match/PlayerSheet';
import MatchSheetTeam from '@/components/match/TeamSheet';
import MatchSheetTrainer from '@/components/match/TrainerSheet';
import MatchSheetScout from '@/components/match/ScoutSheet';

export default {
  name: 'home-mixin',

  components: {
    MatchSheetPlayer,
    MatchSheetTeam,
    MatchSheetTrainer,
    MatchSheetScout,
  },

  data() {
    return {
      selectedProfile: null,
      showProfile: {
        trainer: false,
        player: false,
        teams: false,
        scout: false,
      },
      contactByDetails: null,
    };
  },

  computed: {
    ...mapState(['user_data']),
  },

  methods: {
    async openProfile(contactByDetails, chatId) {
      let collection;
      const contactId = chatId.replace(this.user_data.id, '');
      this.$store.state.loading = true;

      if (contactByDetails.type === 'player') {
        collection = 'users';
      }
      if (contactByDetails.type === 'teams') {
        collection = 'teams';
      }
      if (contactByDetails.type === 'trainer') {
        collection = 'trainers';
      }
      if (contactByDetails.type === 'scout') {
        collection = 'scouts';
      }

      const profile = await db
        .collection(collection)
        .doc(contactId)
        .get({ source: 'server' })
        .then((snapshot) => snapshot.data());

      this.selectedProfile = profile;
      this.showProfile[contactByDetails.type] = true;
      this.$store.state.loading = false;
    },
  },
};
